// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AutomationsSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="AutomationsSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M16.824 6.979h-.002a1.498 1.498 0 0 0-1.296-2.247h-2.948l3.691 3.207z" />
      <path d="m4.214 9.812.93-4.799H4.038A1.498 1.498 0 0 0 2.74 7.26l1.474 2.554z" />
      <path d="M8.568 17.006H8.566a1.498 1.498 0 0 0 2.595 0l1.474-2.554-4.622 1.594z" />
      <path d="M17.46 10.706a1.47 1.47 0 0 0-.515-1.038L8.82 2.61a1.4 1.4 0 0 0-.15-.114Q8.651 2.482 8.632 2.471a1.4 1.4 0 0 0-.156-.087H8.473A1 1 0 0 0 8.309 2.32L8.267 2.306a2 2 0 0 0-.164-.04H8.098a2 2 0 0 0-.17-.02h-.04L7.843 2.244l-.12.005H7.72a2 2 0 0 0-.167.025l-.04.01a2 2 0 0 0-.16.042H7.35A2 2 0 0 0 7.194 2.39L7.156 2.41a2 2 0 0 0-.145.08 2 2 0 0 0-.135.102L6.844 2.619a1.5 1.5 0 0 0-.229.255L6.59 2.909a1.3 1.3 0 0 0-.159.318L6.417 3.271A2 2 0 0 0 6.37 3.453L4.318 14.02a2 2 0 0 0-.025.195v.063l.001.127q.002.036.007.07a1.4 1.4 0 0 0 .065.296q.008.03.02.063a2 2 0 0 0 .053.12l.02.043a1.4 1.4 0 0 0 .092.151l.025.033a2 2 0 0 0 .084.106l.044.046a1 1 0 0 0 .08.08l.052.045.088.067.056.04a1 1 0 0 0 .101.058q.026.015.053.028a1 1 0 0 0 .144.061q.009.005.02.008a1 1 0 0 0 .172.048q.026.006.054.01a1 1 0 0 0 .125.017l.069.003.067.003.065-.003h.033a2 2 0 0 0 .174-.022q.019-.002.036-.007a1.4 1.4 0 0 0 .184-.05l6.714-2.314v.003l3.461-1.193a1.496 1.496 0 0 0 1.008-1.51m-4.168-.134-4.313 2.49a1.105 1.105 0 0 1-1.658-.957v-4.98c0-.85.92-1.382 1.658-.956l4.313 2.49a1.104 1.104 0 0 1 0 1.913" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AutomationsSignetIcon = /* @__PURE__ */ Object.assign(
  AutomationsSignetIconComponent,
  { displayName: 'AutomationsSignetIcon' },
);
